import { useEffect, useState } from 'react';
import useFetch from '../../../hook/useFetch';
import useHeaderRefresh from '../../../hook/useHeaderRefresh';

export default function Reviews({ productId = null, embedded = false }) {
  const { get, update, del } = useFetch();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = (nextPage = page) => {
    setLoading(true);
    return get('/admin/reviews', { page: nextPage, status, ...(productId ? { product_id: productId } : {}) },
      message => { setLoading(false); setError(String(message)); }, data => {
        setLoading(false);
        setRows(Array.isArray(data?.rows) ? data.rows : []);
        setPage(Number(data?.page || 1));
        setPages(Number(data?.pages || 1));
        setTotal(Number(data?.total || 0));
        setError('');
      }, message => { setLoading(false); setError(String(message)); });
  };

  useEffect(() => { load(1); }, [productId, status]);
  useHeaderRefresh(() => load(page));

  const moderate = (id, nextStatus) => {
    setBusyId(id);
    update('/admin/review', { id, status: nextStatus }, message => { setBusyId(null); setError(String(message)); },
      () => { setBusyId(null); load(); }, message => { setBusyId(null); setError(String(message)); });
  };

  const remove = async id => {
    setBusyId(id);
    const confirmed = await del('/admin/review', { id }, message => { setBusyId(null); setError(String(message)); },
      () => { setBusyId(null); load(); }, message => { setBusyId(null); setError(String(message)); });
    if (!confirmed) setBusyId(null);
  };

  return <section className={`${embedded ? 'mt-4' : 'container-fluid py-3'} card shadow-sm p-4`} aria-label="Produktbewertungen verwalten">
    <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
      <div><h2 className={embedded ? 'h4' : 'h2'}>{embedded ? 'Bewertungen für dieses Produkt' : 'Produktbewertungen'}</h2><p className="text-muted mb-0" role="status" aria-live="polite">{loading ? 'Bewertungen werden aktualisiert …' : `${total} Einträge. Nur freigegebene Bewertungen sind öffentlich sichtbar.`}</p></div>
      <div><label className="form-label" htmlFor={embedded ? 'product-review-status' : 'review-status'}>Status</label><select id={embedded ? 'product-review-status' : 'review-status'} className="form-select" value={status} onChange={event => setStatus(event.target.value)}><option value="">Alle</option><option value="pending">Ausstehend</option><option value="approved">Freigegeben</option><option value="rejected">Abgelehnt</option></select></div>
    </div>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    <div className="table-responsive"><table className="table table-striped align-middle"><thead><tr><th>Produkt</th><th>Name</th><th>Bewertung</th><th>Kommentar</th><th>Status</th><th>Datum</th><th>Aktionen</th></tr></thead><tbody>
      {rows.map(review => <tr key={review.id}>
        <td>{review.product_title}<small className="d-block text-muted">{review.custom_key ? `Eigener Schlüssel: ${review.custom_key}` : `Produkt-ID: ${review.product_id}`}</small></td>
        <td>{review.reviewer_name}</td><td>{review.rating ? `${'★'.repeat(Number(review.rating))}${'☆'.repeat(5 - Number(review.rating))}` : 'Nur Kommentar'}</td>
        <td><div style={{ minWidth: 180, maxWidth: 450, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{review.comment || '—'}</div></td>
        <td><span className={`badge ${review.status === 'approved' ? 'bg-success' : review.status === 'rejected' ? 'bg-secondary' : 'bg-warning text-dark'}`}>{review.status}</span></td>
        <td>{review.created_at}</td>
        <td><div className="d-flex flex-wrap gap-1">
          {review.status !== 'approved' && <button className="btn btn-sm btn-outline-success" type="button" disabled={busyId === review.id} onClick={() => moderate(review.id, 'approved')}>Freigeben</button>}
          {review.status !== 'rejected' && <button className="btn btn-sm btn-outline-secondary" type="button" disabled={busyId === review.id} onClick={() => moderate(review.id, 'rejected')}>Ablehnen</button>}
          <button className="btn btn-sm btn-outline-danger" type="button" disabled={busyId === review.id} onClick={() => remove(review.id)}>Löschen</button>
        </div></td>
      </tr>)}
      {rows.length === 0 && <tr><td colSpan={7}>Keine Bewertungen für diese Auswahl.</td></tr>}
    </tbody></table></div>
    <nav className="d-flex justify-content-between align-items-center gap-2" aria-label="Bewertungen-Seiten"><span>Seite {page} von {pages}</span><div className="d-flex gap-2"><button type="button" className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => load(page - 1)}>Zurück</button><button type="button" className="btn btn-outline-secondary btn-sm" disabled={page >= pages} onClick={() => load(page + 1)}>Weiter</button></div></nav>
  </section>;
}
